import React from 'react';
import parse from 'html-react-parser';

export function HTMLToReact({ value }: { value?: any }): any {
  const cleanHTML = value ? parse(value) : null;
  return <React.Fragment>{value ? cleanHTML : '-'}</React.Fragment>;
}
